import React, { ComponentProps, PropsWithChildren } from 'react'
import styled from 'styled-components'

export type NavMenuProps = ComponentProps<typeof StyledNavMenu> & {
  //
}

export const StyledNavMenu = styled.div`
  list-style-type: none;
  margin: 0 ${props => props.theme.typography.pxToRem(-10)};
  padding: 0;

  ${props => props.theme.breakpoints.only('md')} {
    padding-left: ${props => props.theme.typography.pxToRem(30)};
  }

  ${props => props.theme.breakpoints.up('lg')} {
    margin: 0 ${props => props.theme.typography.pxToRem(-30)};
  }

    ${props => props.theme.breakpoints.up('lg')} {
        display: flex;
        justify-content: center;
    }
`

export const NavMenu: React.FC<PropsWithChildren<NavMenuProps>> = (props) => {
  return (
    <StyledNavMenu {...props} />
  )
}
